export default "__VITE_ASSET__DLx3d7ny__"